var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notesAndDiscussionsRootBox" },
    _vm._l(_vm.dataList, function(item, index) {
      return _c("div", { key: index, staticClass: "notesAndDiscussionsItem" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/icon/icon_note_discus_" + index + ".png")
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", [_vm._v(_vm._s(item.content))]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(item.describe))])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8eec200", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8eec200","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mNotesAndDiscussions.vue
// module id = null
// module chunks = 